import { merge } from 'lodash';

import xhr from './../../utils/xhr';
import { GET } from './../../constants';

const api = {

    loadSingleArticle(articleId, injectEntity, requestType = GET, requestPayload = null) {
        let data = undefined,
            requestMethod = requestType.toLowerCase();

        if (injectEntity) {
            data = { riskEntityId: injectEntity };
        }

        if (requestPayload) {
            data = merge({}, data, requestPayload);
        }

        return xhr[requestMethod]({
            url: '/api/entities/preview-article/' + articleId,
            data: data
        }).then((response) => {
            return response.body;
        });
    }

};

export default api;


// WEBPACK FOOTER //
// ./src/scripts/reusable/PreviewArticle/ViewArticle.api.js